<template>
  <v-snackbar v-model="hasUpdate" :timeout="60000">
    <span class="body-1">Nova versão!</span>
    <template v-slot:action="{ attrs }">
      <v-btn dark v-bind="attrs" @click="update()" color="info" class="mr-2">
        <v-icon class="mr-2">system_update_alt</v-icon>
        Atualizar
      </v-btn>
      <v-btn dark icon v-bind="attrs" @click="hasUpdate = false">
        <v-icon>close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data () {
    return {
      hasUpdate: false,
      refreshing: false,
      registration: null
    }
  },
  created () {
    document.addEventListener('hasUpdate', (event) => {
      this.registration = event.detail
      this.hasUpdate = true
    }, { once: true })

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      // Here the actual reload of the page occurs
      window.location.reload()
    })
  },
  methods: {
    update () {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }
}
</script>

<style scoped>
.v-snack >>> .v-snack__wrapper {
  flex-wrap: wrap;
}
</style>
